// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"76faba1f","453":"6d19bdc0","557":"474214fc","667":"5ae566cc","977":"dff86d74"}[chunkId] + ".chunk.js";
};